"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BI_SOURCES = void 0;
var BI_SOURCES;
(function (BI_SOURCES) {
    BI_SOURCES[BI_SOURCES["VOD_SRC_ID"] = 71] = "VOD_SRC_ID";
})(BI_SOURCES = exports.BI_SOURCES || (exports.BI_SOURCES = {}));
//# sourceMappingURL=sources.js.map